export default __webpack_public_path__ + "static/image-0d423d660c6973a02d9a3e4fe4a7dbf6.png";